const SESSION_STORAGE = {
  SHOWED_SHARE_CAMPAIGN_LOGIN_MODAL:
    'promobit.showed-share-campaign-login-modal',
  IS_SPONSOR_VISITED: 'promobit.is-sponsor-visited',
  INITIAL_SESSION_URL: 'promobit.initial-session-url',
};

export default SESSION_STORAGE;
